//src/app/features/conversations/index.tsx
import { Container } from 'app/layout/dashboardLayout/BoxLayout';
import { IConversation } from 'app/services/messages';
import { Outlet } from 'react-router-dom';
import useMediaQueries from '../../hooks/useMediaQueries';
import ConversationsList from './Components/ConversationsList';
import ConversationsListProvider from './ConversationsListProvider';

export interface IConversationsProps {}

export type TConversations = {
  [id: number]: IConversation;
};
export default function Conversations(props: IConversationsProps) {
  const { md_down: isMobile } = useMediaQueries();

  return (
    <ConversationsListProvider>
      <div className="flex h-full w-full overflow-auto">
        {!isMobile && <ConversationsList width="w-80" />}

        <div className="flex-1 flex h-full flex-col self-stretch ">
          <Outlet />
        </div>
      </div>
    </ConversationsListProvider>
  );
}
